
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWireEndPoint as ObiWireEndPointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wire-end-point.js';
 
 
 

 
 export const ObiWireEndPoint = createComponent({
   react: React,
   tagName: 'obi-wire-end-point',
   elementClass: ObiWireEndPointElement,
   events: {
     
   }
  });
 
 